import { render, staticRenderFns } from "./SidebarSearch.vue?vue&type=template&id=5dcde4ac&scoped=true"
import script from "./SidebarSearch.vue?vue&type=script&lang=js"
export * from "./SidebarSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcde4ac",
  null
  
)

export default component.exports